import {createReducer} from "./index";
import {GET_MY_PROFILE_DONE} from "../actions/users";
import moment from "moment";

const profileReducer = createReducer({
  },
  {
    [GET_MY_PROFILE_DONE]: (state, action) => {
      if (!state.datemodified || moment(action.payload.datemodified) > moment(state.datemodified)) return action.payload
      return state
    }
    // 'ACTION_NAME': function (state, action) -> new_state
  });

export default profileReducer;



// WEBPACK FOOTER //
// ./src/reducers/profile.js